import {
  filterStaticImageAssetsForIds,
  getStaticAssetPath,
  type StaticImageAsset
} from "@/utils/static-assets";

const environmentImageAssetsSupportedByApp: StaticImageAsset[] = [
  {
    id: "Champalimaud_Lissabon_2020",
    url: getStaticAssetPath("img/environments/champalimaud-lissabon.png")
  },
  {
    id: "Champalimaud_Lissabon_Night_2021",
    url: getStaticAssetPath("img/environments/champalimaud-lissabon-night.png")
  },
  {
    id: "ChicagoNight",
    url: getStaticAssetPath("img/environments/chicago-night.png")
  },
  {
    id: "ChicagoNight_Lamborghini",
    url: getStaticAssetPath("img/environments/chicago-night-lamborghini.png")
  },
  {
    id: "AdPersonam_Studio_Day",
    url: getStaticAssetPath("img/environments/adpersonam-studio-day.png")
  },
  {
    id: "AdPersonam_Studio_Night",
    url: getStaticAssetPath("img/environments/adpersonam-studio-night.png")
  },
  {
    id: "Atrium_Night",
    url: getStaticAssetPath("img/environments/atrium-night.png")
  },
  {
    id: "Atrium_Day",
    url: getStaticAssetPath("img/environments/atrium-day.png")
  },
  {
    id: "Atrium_Night",
    url: getStaticAssetPath("img/environments/atrium-night.png")
  },
  {
    id: "CanyonTrail",
    url: getStaticAssetPath("img/environments/canyontrail-day.png")
  },
  {
    id: "CanyonTrailNight",
    url: getStaticAssetPath("img/environments/canyontrail-night.png")
  },
  {
    id: "NewStudio_Day",
    url: getStaticAssetPath("img/environments/newstudio-day.png")
  },
  {
    id: "NewStudio_Night",
    url: getStaticAssetPath("img/environments/newstudio-night.png")
  },
  {
    id: "Racing_Day",
    url: getStaticAssetPath("img/environments/racing-day.png")
  },
  {
    id: "Racing_Night",
    url: getStaticAssetPath("img/environments/racing-night.png")
  },
  {
    id: "Thunderstorm_animated",
    url: getStaticAssetPath("img/environments/thunderstorm-day.png")
  },
  {
    id: "Thunderstorm_Night_animated",
    url: getStaticAssetPath("img/environments/thunderstorm-night.png")
  },
  {
    id: "Studio_Lamborghini",
    url: getStaticAssetPath("img/environments/studio.png")
  },
  {
    id: "Constantia_SouthAfrica",
    url: getStaticAssetPath("img/environments/constantia-southafrica.png")
  },
  {
    id: "LAVista",
    url: getStaticAssetPath("img/environments/la-vista.png")
  },
  {
    id: "Metro_Dubai_2021",
    url: getStaticAssetPath("img/environments/metro-dubai.png")
  },
  {
    id: "Meydan_Dubai_2021",
    url: getStaticAssetPath("img/environments/meydan-dubai.jpg")
  },
  {
    id: "MoMa_House",
    url: getStaticAssetPath("img/environments/moma-house-generic-lighting.png")
  },
  {
    id: "MoMa_House_GenericLighting",
    url: getStaticAssetPath("img/environments/moma-house-generic-lighting.png")
  },
  {
    id: "Skyline_Dubai_2021",
    url: getStaticAssetPath("img/environments/skyline-dubai.jpg")
  },
  {
    id: "WhiteRoom",
    url: getStaticAssetPath("img/environments/white-room.png")
  },
  {
    id: "DinoPark_Kapstadt_2020",
    url: getStaticAssetPath("img/environments/mall-kapstadt.jpg")
  },
  {
    id: "PariserPlatz_Berlin_2020",
    url: getStaticAssetPath("img/environments/pariser-platz.jpg")
  },
  {
    id: "AllianzArena",
    url: getStaticAssetPath("img/environments/allianz-arena.png")
  },
  {
    id: "Arken_Museum_Denmark",
    url: getStaticAssetPath("img/environments/arken-museum-denmark.png")
  },
  {
    id: "ArtscapeTheatre_Kapstadt_2020",
    url: getStaticAssetPath("img/environments/artscape-kapstadt.png")
  },
  {
    id: "Festspielhaus_Erl_2020",
    url: getStaticAssetPath("img/environments/festspielhaus.png")
  },
  {
    id: "RotterdamCS",
    url: getStaticAssetPath("img/environments/rotterdamcs.png")
  },
  {
    id: "TableMountain",
    url: getStaticAssetPath("img/environments/table-mountain.png")
  },
  {
    id: "Heliport_Hochgurgl",
    url: getStaticAssetPath("img/environments/heliport-hochgurgl.png")
  },
  {
    id: "Mood_Cafe_2021",
    url: getStaticAssetPath("img/environments/mood-cafe.png")
  },
  {
    id: "VW_Road_Day",
    url: getStaticAssetPath("img/environments/road-day.png")
  },
  {
    id: "VW_Road_Night",
    url: getStaticAssetPath("img/environments/road-night.png")
  },
  {
    id: "VW_Villa_Day",
    url: getStaticAssetPath("img/environments/villa-day.png")
  },
  {
    id: "VW_Villa_Night",
    url: getStaticAssetPath("img/environments/villa-night.png")
  },
  {
    id: "VW_Neutral",
    url: getStaticAssetPath("img/environments/neutral.png")
  },
  {
    id: "Agora_2021",
    url: getStaticAssetPath("img/environments/agora.png")
  },
  {
    id: "Cabo_Mallorca",
    url: getStaticAssetPath("img/environments/cabo-mallorca.png")
  },
  {
    id: "WhiteRoom_SeatCupra",
    url: getStaticAssetPath("img/environments/white-room-seat.png")
  },
  {
    id: "CongressCentre_Torun_Polen",
    url: getStaticAssetPath("img/environments/congress-centre-torun-polen.jpg")
  },
  {
    id: "FarmHouse_Zegocina_Polen",
    url: getStaticAssetPath("img/environments/farm-house-zegocina-polen.jpg")
  },
  {
    id: "SculpturePark_Tasmania",
    url: getStaticAssetPath("img/environments/sculpture-park-tasmania.jpg")
  },
  {
    id: "ParkingSpot_CabotTrail_Canada",
    url: getStaticAssetPath("img/environments/parkingspot_cabottrail_canada.jpg")
  },
  {
    id: "House_Chambord_Canada",
    url: getStaticAssetPath("img/environments/house_chambord_canada.png")
  },
  {
    id: "Museum_Zory_Polen",
    url: getStaticAssetPath("img/environments/museum_zory_polen.png")
  },
  {
    id: "Playa_de_Concreto",
    url: getStaticAssetPath("img/environments/playa-de-concreto.png")
  },
  {
    id: "Villa_Alcobendas_Madrid",
    url: getStaticAssetPath("img/environments/villa-alcobendas-madrid.png")
  },
  {
    id: "Private_Villa",
    url: getStaticAssetPath("img/environments/private-villa.png")
  },
  {
    id: "Docks",
    url: getStaticAssetPath("img/environments/docks.png")
  },
  {
    id: "Docks_Day",
    url: getStaticAssetPath("img/environments/docks-day.jpg")
  },
  {
    id: "Centro_Niemeyer_Aviles",
    url: getStaticAssetPath("img/environments/centro-niemeyer.png")
  },
  {
    id: "Hilltop_Seaview",
    url: getStaticAssetPath("img/environments/hilltop-seaview.png")
  },
  {
    id: "Hilltop_Seaview_Midday",
    url: getStaticAssetPath("img/environments/hilltop-seaview-midday.png")
  },
  {
    id: "Inselhalle_Lindau_2020",
    url: getStaticAssetPath("img/environments/inselhalle-lindau.png")
  },
  {
    id: "Meydan_Grandstand_Dubai_2021",
    url: getStaticAssetPath("img/environments/meydan-grandstand-dubai.png")
  },
  {
    id: "Museum_StPoelten_2020",
    url: getStaticAssetPath("img/environments/museum-st-poelten.png")
  },
  {
    id: "Residential_Neighborhood_Noon",
    url: getStaticAssetPath("img/environments/residential-neighborhood-noon.jpg")
  },
  {
    id: "Residential_Neighborhood_Dusk",
    url: getStaticAssetPath("img/environments/residential-neighborhood-dusk.jpg")
  },
  {
    id: "Residential_Neighborhood_Rain",
    url: getStaticAssetPath("img/environments/residential-neighborhood-rain.jpg")
  },
  {
    id: "Country_Road_Summer_Noon",
    url: getStaticAssetPath("img/environments/country-road-summer-noon.jpg")
  },
  {
    id: "Country_Road_Summer_Evening",
    url: getStaticAssetPath("img/environments/country-road-summer-evening.jpg")
  },
  {
    id: "Country_Road_Winter_Clearsky",
    url: getStaticAssetPath("img/environments/country-road-winter-clearsky.jpg")
  },
  {
    id: "Mediterranean_Village_Noon",
    url: getStaticAssetPath("img/environments/mediterranean-village-noon.jpg")
  },
  {
    id: "Mediterranean_Village_Night",
    url: getStaticAssetPath("img/environments/mediterranean-village-night.jpg")
  },
  {
    id: "Alpine_Lake",
    url: getStaticAssetPath("img/environments/alpine-lake.jpg")
  },
  {
    id: "GravelPit",
    url: getStaticAssetPath("img/environments/gravel-pit.jpg")
  },
  {
    id: "Constantia_SouthAfrica_Streaming",
    url: getStaticAssetPath("img/environments/constantia-southafrica.png")
  },
  {
    id: "SculpturePark_Tasmania_Streaming",
    url: getStaticAssetPath("img/environments/sculpture-park-tasmania.jpg")
  },
  {
    id: "Villa_Alcobendas_Madrid_Streaming",
    url: getStaticAssetPath("img/environments/villa-alcobendas-madrid.png")
  },
  {
    id: "Private_Villa_Streaming",
    url: getStaticAssetPath("img/environments/private-villa.png")
  },
  {
    id: "Urban_Home_El_Mar",
    url: getStaticAssetPath("img/environments/urban-home-el-mar.png")
  }
];

export function getStaticImageAssetsOfEnvironments(environments: string[]): StaticImageAsset[] {
  return filterStaticImageAssetsForIds(environmentImageAssetsSupportedByApp, environments);
}
